import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../identity/auth.service';

/**
 * Guard that checks if page can be activated if user is authenticated -> login page.
 */
@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let canActivate = !this.authService.isAuthenticated();
    if (canActivate == false) {
      return this.router.parseUrl('/');
    }
    else {
      return true;
    }
  }
  
}
